import React from 'react';
import SEO from './SEO';

export default function LegalLayout({ title, subtitle, path, schema, lastUpdated, children }) {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 space-y-10">
      <SEO title={`${title} | Moon Yoga Fredericia`} description={subtitle || title} path={path} schema={schema} />

      {/* Uniform Header Header Section */}
      <div className="text-center space-y-3 pb-6 border-b border-brand-primary/10">
        <span className="text-xs sm:text-sm tracking-[0.25em] uppercase text-brand-primary font-semibold block">
          Juridisk information
        </span>
        <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-brand-primary font-semibold tracking-wide">
          {title}
        </h1>
        {subtitle && (
          <p className="text-base sm:text-lg text-brand-muted max-w-2xl mx-auto leading-relaxed">
            {subtitle}
          </p>
        )}
        {lastUpdated && (
          <p className="text-xs text-brand-muted/80 pt-1 italic">
            Senest opdateret: {lastUpdated}
          </p>
        )}
      </div>

      {/* Main Content Body */}
      <div className="prose prose-brand max-w-none text-brand-text/90 text-base sm:text-lg leading-relaxed space-y-6">
        {children}
      </div>
    </div>
  );
}
